import {
  CuratedColumnSymbology,
  CUSTOM_THEME,
  DEFAULT_OPACITY,
  InterpolationTypes,
  PaintColorTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<string, Record<string, CuratedColumnSymbology[]>> = {
  '/public/dataset/california_audubon_important_bird_areas': {
    iba_status: [
      {
        type: SymbologyTypes.FILL,
        paint: {
          'fill-color': {
            property: 'iba_status',
            type: PaintColorTypes.CATEGORICAL,
            stops: [
              { value: 'Global', color: '#32f0ff' },
              { value: 'State', color: '#6cffb1' },
            ],
          },
          'fill-opacity': DEFAULT_OPACITY,
        },
        display_hints: {
          scale: SymbologyScales.CATEGORICAL,
          distribution: null,
          interpolation: InterpolationTypes.CATEGORICAL,
          theme: CUSTOM_THEME,
        },
      },
    ],
  },
};

export default symbologies;
